import React, { Component } from 'react';
import BRSpan from './BRSpan';

class InfoBlock extends Component {

    render() {
        let unit = this.props.unit;
        let fontClass = this.props.fontClass ? this.props.fontClass : null;
        let innerFontFamily = this.props.fontClass ? null : "Ostrich";
        let spanFontFamily = this.props.fontClass ? null : "aleo-light";

        let {
            width = unit * 5.5, //450,
            height = unit * 1.35, //135,
            //style,
            //className
        } = this.props;

        const innerStyle = {
            textAlign: 'left',
            marginTop: unit * -2, //-200,
            marginLeft: unit * 1.5,//140,
            marginBottom: unit * 0.6, //60,
            borderRadius: unit * 0.15, //15,
            width: width,
            fontFamily: innerFontFamily,
            fontSize: unit * 0.2,
            position: 'absolute',
            left: 0,
            top: unit * .5,
        };

        innerStyle.width = innerStyle.maxWidth = width;
        innerStyle.height = innerStyle.maxHeight = height;

        //let classes = [className, 'DonorInfo'];

        return (
            <span className={fontClass} aria-label={this.props.header} style={{ position: 'relative', zIndex: 20 }}>
                <span className="DonorInfo" style={innerStyle}>

                    <div style={{ height: '100%', width: '80%', marginLeft: '15%' }} className="valigner">
                        <div className="valigner-item">
                            <span style={{ fontSize: unit*0.35, color: this.props.headerColor }}><BRSpan preWrap str={this.props.header}/></span><br />
                            <span style={{ fontFamily: spanFontFamily, color: "#333344" }}><BRSpan preWrap str={this.props.text}/></span>
                        </div>
                    </div>

                </span>
            </span>
        )
    }
}

module.exports = InfoBlock;

// .DonorInfo h2 {
//     padding-top: 32px;
//     color: #44b4c2;
// }
// .DonorInfo p {
//     margin-top: -10px;
//     color: #333344;
// }



// WEBPACK FOOTER //
// ./src/Components/General/InfoBlock.js